<template>
  <div id="system-manage-questionnaire-add">
    <ipub-model title="Supplementary Q&A"
                width="900px"
                :visable="isVisable"
                @confirm="confirm"
                @cancel="cancel">
      <ipub-form ref="manage-questionnaire-add-form"
                 :model="params"
                 :rules="rules">
        <ipub-form-item prop="supplementary"
                        label="Question">
          <ipub-input placeholder="Question"
                      v-model.trim="params.supplementary" />
        </ipub-form-item>
      </ipub-form>
    </ipub-model>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      params: {},
      rules: {},
      index: ''

    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      publisherId: 'getPublisherId',
      domain: 'getDomain'
    })
  },
  watch: {
    isVisable (val) {
      if (!val) {
        this.params = {}
      }
    }
  },
  mounted () {
    this.getRules()
  },
  methods: {
    async getQuery (val, index) {
      this.params = val
      this.index = index
    },
    async confirm () {
      const flag = this.$refs['manage-questionnaire-add-form'].validate()
      flag && this.$emit('confirm', this.params, this.index)
    },
    cancel () {
      this.$emit('cancel')
    },
    getRules () {
      this.rules = {
        supplementary: [
          {
            required: true,
            message: 'Supplementary Q&A' + this.LANGUAGE[this.language].noEmpty
          }
        ]
      }
    }
  }
}
</script>
